import React from 'react';
import Faqs from '../../components/landingPageComponent/Faqs';
import Navbar from '../../components/landingPageComponent/Navbar';
import ScrollTop from '../../components/landingPageComponent/ScrollTop';
import Footer from '../../components/landingPageComponent/Footer';

const FaqPage = () => {
	return (
		<div>
			<Navbar />
			<Faqs />
			<ScrollTop />
			<Footer />
		</div>
	);
};

export default FaqPage;
